import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/individual-service-kitchen-renovation/page.tsx");
